import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "email-digest",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "email-digest" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [],
  };
};
